export const getPlayer = (playerId, players) => {
    return players.find(({ player: { id } }) => id === playerId);
};
//# sourceMappingURL=getPlayer.js.map